import React from 'react';
import Article from '../../components/article/Article';
import { blog01,blog02,blog03, blog04 } from './imports';
import './blog.css';

const Blog = () => (
  <div className="taasa__blog section__padding" id="blog">
    <div className="taasa__blog-heading">
      <h1 className="gradient__text">A lot is happening, <br /> and we are documenting it, read our blog to find out.</h1>
    </div>
    <div className="taasa__blog-container">
      <div className="taasa__blog-container_groupA">
        <Article imgUrl={blog01} date="Oct 04, 2022" text="Taasa — Introducing the African startup making roads safer." link="https://taasa.medium.com/taasa-introducing-the-african-startup-making-roads-safer-f3a167f96780" />
      </div>
    
      
    
        <div className="taasa__blog-container_groupB">
        <Article imgUrl={blog02} date="Jan 24, 2023" text="A comparison of the Ugandan and UK road safety sectors, what lessons can Uganda learn?" link="https://taasa.medium.com/a-contrast-of-the-uk-and-uganda-road-safety-sectors-what-lessons-can-uganda-learn-cc591239088f" />
        </div>
        <div className="taasa__blog-container">
        <Article imgUrl={blog03} date="Sep 06, 2023" text="Why you should have a driver monitoring system in your fleet." link="https://taasa.medium.com/the-crucial-role-of-driver-monitoring-systems-in-fleet-management-bcd09046bde"/>
        </div>
        <div className="taasa__blog-container">
        <Article imgUrl={blog04} date="Sep 11, 2023" text="Why it's important to have insurance policies for your family." link="https://taasa.medium.com/protecting-what-matters-most-the-importance-of-family-insurance-policies-4a987471223c" />
        </div>
        
        {
        /*
       
        <div className="taasa__blog-container">
        <Article imgUrl={blog05} date="Dec 25, 2024" text="Does road safety really matter to you? Find out why it should." link="https://taasa.medium.com/un-2030-roadsafety-goal-f3a167f96780" />
        </div>
        <Article imgUrl={blog05} date="Jan 26, 2025" text="Taasa signs groundbreaking partnerhsip." link="https://taasa.medium.com/un-2030-roadsafety-goal-f3a167f96780" />
        </div>
        */}
    </div>
  </div>
);

export default Blog;
